module.exports = __webpack_public_path__ + "img/proyecto_7.c3275886.webp";